import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { ApiCommonService } from '@src/app/core/services/api-common.service';
import { ApiWebSubmissionService } from '@src/app/core/services/api-web-submission.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiRbacService, AppConfig, StorageService } from 'sigv-library';
import { isNullOrEmpty } from 'sigv-library/util';
import { ExtranetAuthenticationService } from '../services/extranet-authentication.service';

@Injectable({
  providedIn: 'root',
})
export class ExtranetLoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private appConfig: AppConfig,
    private apiCommonService: ApiCommonService,
    private apiRbacService: ApiRbacService,
    private apiWebSubmissionService: ApiWebSubmissionService,
    private extranetAuthenticationService: ExtranetAuthenticationService,
    private storageService: StorageService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    if (
      this.extranetAuthenticationService.isAuthenticated &&
      !this.extranetAuthenticationService.checkIdTokenExpiration()
    ) {
      if (isNullOrEmpty(this.extranetAuthenticationService.currentUserValue)) {
        // get user profile from local or session storage
        const userProfile =
          this.storageService.local.getItem(
            this.storageService.keys.UserProfile
          ) ||
          this.storageService.session.getItem(
            this.storageService.keys.UserProfile
          );
        if (!isNullOrEmpty(userProfile)) {
          return this.extranetAuthenticationService
            .initLoginUserData(userProfile!)
            .pipe(
              tap((isSuccess) => {
                if (isSuccess) {
                  this.router.navigate(['/']);
                }
              })
            );
        }
      }
      this.router.navigate(['/']);
      return false;
    } else {
      // clear permission
      this.extranetAuthenticationService.logout();
    }

    this.apiRbacService.setBaseUrl(this.appConfig.getApiUrl('rbac'));
    this.apiCommonService.setBaseUrl(this.appConfig.getApiUrl('webSubmission'));
    this.apiWebSubmissionService.setBaseUrl(
      this.appConfig.getApiUrl('webSubmission')
    );
    return true;
  }
}
